// selected* live only for the current session: cleared on workspace switch and absent
// after a reload, so fall back to the saved portfolio for the active project.
export const buildUserProfileDetails = (userInfo: any) => {
  const portfolio = (userInfo?.userPortfolios || []).find(
    (pf: any) => pf.project_id == userInfo?.preferredProject
  );

  return {
    role: userInfo?.selectedRole ?? portfolio?.profile,
    brands: userInfo?.selectedBrands ?? portfolio?.brands,
    functions: userInfo?.selectedFunctions ?? portfolio?.funcs,
    goals: userInfo?.selectedGoals ?? portfolio?.goals,
  };
};
